module.exports = __webpack_public_path__ + "img/jack-full.723f7869.png";